export default __webpack_public_path__ + "static/media/disconnect-from-vpn.bd1fd9d8.jpg";